import { createFileRoute } from "@tanstack/react-router"

import { NotificationDetail } from "@/components/others/notification"

export const Route = createFileRoute("/_screen/notification/$id")({
  component: NotificationDetailPage
})

function NotificationDetailPage() {
  const { id } = Route.useParams()
  return <NotificationDetail id={id} />
}
